

let language = {
    "UPLOAD_FILE": "Upload File",
    "NAME": "Name",
    "FORMAT": "Format",
    "SIZE": "Size",
    "STATE": "Status",
    "UPLOAD_CANCEL": "Cancel",
    "RETRY": "Retry",
    "CHANGE": "Change",
    "DELETE": "Delete",
    "NETWORK_ERROR": "There is a problem with current network communications.",
    "INIT": "Pending",
    "PENDING": "Pending",
    "UPLOADING": "Uploading",
    "SUCCESSED": "Successed",
    "FAILED": "Failed",


};


export { language }